import * as PIXI from "pixi.js";
import Layers from "../../../../../src/layers/Layers";
import Line from "../../../../../src/entities/Line/Line";
import { Coord } from "../../../../../src/types/Interface";
import { KITE_COLORS } from "../types/Config";
import getCenterOfTwoCoords from "../../../../../src/utils/coord/getCenterOfTwoCoords";
import { eventBus, EnumEventBus } from "../managers/EventBus";


export default class Kite extends PIXI.Container {
	private Layers = Layers.getInstance();
	private Lines: Line[] = [];
	private Graphics: PIXI.Graphics[] = [];
	private cCoord: Coord;

	constructor(cCoord: Coord) {
		super();
		this.cCoord = cCoord;
		this.addGraphics();
		this.addLines();

		eventBus.on(EnumEventBus.KiteMode, (v: boolean) => {
			if (!v) {
				this.Graphics.forEach(g => g.clear());
				this.Lines.forEach(l => l.clear());
			}
		})
	}
	addGraphics() {
		this.Graphics = [new PIXI.Graphics(), new PIXI.Graphics(), new PIXI.Graphics(), new PIXI.Graphics()];
		this.Graphics.forEach((g, i) => this.Layers.Bottom.addChild(g));
	}
	addLines(){
		Array(2).fill("").forEach(()=>{
			const line = new Line();
			this.Layers.Middle.addChild(line);
			this.Lines.push(line);
		})
	}
	fillTriangles(points: Coord[], intersecCoord: Coord) {
		const midPoint = getCenterOfTwoCoords(points[0], points[1]);
		const Points = [points[0], this.cCoord, points[1], intersecCoord];

		this.Graphics.forEach((g, i) => {
			const firstPoint = midPoint
			const secondPoint = Points[i];
			const thirdPoint = Points[(i + 1) % Points.length];

			g.clear();
			g.moveTo(firstPoint.x, firstPoint.y);
			g.lineTo(secondPoint.x, secondPoint.y);
			g.lineTo(thirdPoint.x, thirdPoint.y);
			g.fill(KITE_COLORS[i])
		});
	}

	draw(points: Coord[] = [], intersecCoord: Coord) {
		this.Lines[0].draw(points[0], points[1]);
		this.Lines[1].draw(this.cCoord, intersecCoord);
		this.fillTriangles(points, intersecCoord);
	}
}


